import { apiCall } from "../../services/api-service";
// Generate Transport Report
export const transportReportApi = async (body) => {
  try {
    const response = await apiCall("POST", "report", body);
    return response;
  } catch (err) {
    console.error("Error generating report:", err);
    return err.response;
  }
};

// Save Template
export const saveTemplateApi = async (body) => {
  try {
    const response = await apiCall("POST", "report/template", body);
    return response;
  } catch (err) {
    console.error("Error saving template:", err);
    return err.response;
  }
};

/**
 * Get Templates for Auto-suggestion
 * @param {Object} params - Query parameters
 */
export const getTemplatesApi = async (params) => {
  try {
    const response = await apiCall("GET", "report/template/autocomplete", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching templates:", err);
    return err.response;
  }
};

/**
 * Get Template details by ID
 * @param {string|number} id - Template ID
 */
export const getTemplateByIdApi = async (id) => {
  try {
    const response = await apiCall("GET", `report/template/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching template details:", err);
    return err.response;
  }
};

/**
 * Get all available Report Types
 */
export const getReportTypesApi = async () => {
  try {
    const response = await apiCall("GET", "report/type");
    return response;
  } catch (err) {
    console.error("Error fetching report types:", err);
    return err.response;
  }
};
//Download base64 file
export const downloadBase64File = (base64String, fileName) => {
  try {
    const base64Data = base64String.replace(/^data:.*,/, "");
    const binary = atob(base64Data);
    const array = [];

    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }

    const blob = new Blob([new Uint8Array(array)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};
//getQuickreport
export const getquickreportApi = async () => {
  try {
    const response = await apiCall("GET", "get_quick_report");
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const exportquickApi = async (apivalue, formattedFromDate, formattedToDate, expected_date) => {
  try {
    const response = await apiCall("GET", apivalue, null, {
      params: {
        from_date: formattedFromDate,
        to_date: formattedToDate,
        expected_date: expected_date,
      },
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
